module.exports = __webpack_public_path__ + "heart.7e40d984.png";